// extracted by mini-css-extract-plugin
export default {"userForm":"user_userForm__TvyiC","roleList":"user_roleList__9d5oh"};